import React, { useCallback, useEffect, useRef, useState } from "react";
import * as XLSX from 'xlsx';
import {
  Backdrop,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useLocation, useNavigate } from "react-router-dom";
import Layout from "components/structure/Layout";
import { AuthData } from "auth/AuthWarpper";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowUpQuestion from "assets/Arrow-up-question.svg";
import EditEnabeldIcon from "assets/edit-enabeled-question.svg";
import EditDisabledIcon from "assets/EditDisabledIcon.svg";
import iconSearchs from "assets/iconSearchs.svg"
import viewEye from "assets/viewEye.svg"
import ExpandAll from "assets/ExpandAll.svg"
import ExpandAllBlue from "assets/ExpandAllBlue.svg"
import CollapseAll from "assets/CollapseAll.svg"
import CollapseAllBlue from "assets/CollapseAllBlue.svg"
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import './Questionnare.css'
import QuestionnareService from "services/QuestionnareService";
import { SnackbarContext } from "context/snackBarContext";
import CommonService from "services/CommonService";
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import { debounce } from 'lodash';
import { CheckBox } from "@mui/icons-material";
import SeasonRegistrationService from "services/SeasonRegistrationService";
import AuditConfirmModal from "./AuditConfirmModal";
import ExportToExcelModal from "./ExportToExcelModal";
import { equalsIgnoreCase } from "utils/utils";
const columns = [
  { id: 'questionCode', label: 'Question code' },
  { id: 'text', label: 'Question Text' },
  { id: 'active', label: 'Active' },
  { id: 'mandatory', label: 'Mandatory' },
  { id: 'audit', label: 'Audit' },
  { id: 'promptAction', label: 'Prompt Action' },
  { id: 'edit', label: 'Edit' },
];

let staticsetSelected = "";
let staticsetPromtActions = "";
let oScroll = false

const QuestionnareContainer = () => {
  const savedState = JSON.parse(sessionStorage.getItem('yourComponentState'));

  const location = useLocation();
  const navigate = useNavigate();
  const { user } = AuthData();
  const [openExportToExcelModal,setOpenExportToExcelModal]=useState(false)
  const [isGlobal, setIsGlobal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeButton, setActiveButton] = useState(null);
  const [clickCollapse, setClickCollapse] = useState(false);
  const [clickExpandable, setClickExpandable] = useState(false);
  const [expanded, setExpanded] = useState(savedState?.expanded || [0]);
  const [cropYears, setCropYears] = useState([]);
  const [cropStages, setCropStages] = useState([]);
  const [selectedCropYear, setSelectedCropYear] = useState('');
  const [selectedCropStages, setSelectedCropStage] = useState('');
  const [modules, setModules] = useState([]);
  const [subModules, setSubModules] = useState([]);
  const [userInput, setUserInput] = useState('');
  const [pickListData, setPickListData] = useState();
  const [moreAttributes, setMoreAttributes] = useState([, { id: 1, name: "active" }, { id: 2, name: "audit" }, { id: 3, name: "mandatory" }]);
  const [selected, setSelected] = useState([]);
  const [promtAction, setPromtActions] = useState();
  const [selectedModuleId, setSelectedModuleId] = useState("");
  const [isAllExpanded, setIsAllExpanded] = useState(null);
  const [isUnpublished, setIsUnpublished] = useState(false);
  const [allUnpublishPublish, setAllUnpublishPublish] = useState([]);
  const [selectedRows, setSelectedRows] = useState([])
  const [scrollPosition, setScrollPosition] = useState()
  const [showContent, setShowContent] = useState(false);
  const [openAuditConfirmModal, setOpenAuditConfirmModal]=useState(false)
  const [auditData, setAuditData]=useState({questionId:null, audit:null})
  const [activeQuestion, setActiveQuestion]=useState(true)
  const [questionType, setQuestionType]=useState("")
  const moduleName = "Manage Operations";
  const functionalityName = "Questionnaire Setup";

  const read_only_user = user?.accessibleModules
    ?.find(module => module.module_name === moduleName)
    ?.accessible_functionalities
    ?.find(func => func.functionality_name === functionalityName)
    ?.read_only;

  const [columns, setColumns] = useState([
    { id: 'questionCode', label: 'Question code' },
    { id: 'text', label: 'Question Text' },
    { id: 'active', label: 'Active' },
    { id: 'mandatory', label: 'Mandatory' },
    { id: 'audit', label: 'Audit' },
    { id: 'promptAction', label: 'Prompt Action' },
    { id: 'edit', label: 'Edit' },
  { id: 'view', label: 'View' }])
  const {
    setOpenAlert,
    setSeverity,
    setMessage,
  } = React.useContext(SnackbarContext);

  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const savedScrollPosition = sessionStorage.getItem('scrollPosition');
    if (savedScrollPosition !== null) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(savedScrollPosition, 10));
      }, 0);
    }
    const handleScroll = () => {
      sessionStorage.setItem('scrollPosition', window.scrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  let isAllSelected =
    moreAttributes.length > 0 && selected.length === moreAttributes.length;
  // Load saved state from sessionStorage when the component mounts
  useEffect(() => {
    if (savedState) {
      setIsGlobal(savedState.isGlobal || false);
      setLoading(savedState.loading || false);
      setActiveButton(savedState.activeButton || null);
      setClickCollapse(savedState.clickCollapse || false);
      setClickExpandable(savedState.clickExpandable || false);
      setExpanded(savedState.expanded || [0]);
      setCropYears(savedState.cropYears || []);
      setCropStages(savedState.cropStages || []);
      setSelectedCropYear(savedState.selectedCropYear || '');
      setSelectedCropStage(savedState.selectedCropStages || '');
      setModules(savedState.modules || []);
      setSubModules(savedState.subModules || []);
      setUserInput(savedState.userInput || '');
      setPickListData(savedState.pickListData);

      setSelected(savedState.selected || []);
      setPromtActions(savedState.promtAction);
      setSelectedModuleId(savedState.selectedModuleId || '');
      setIsAllExpanded(savedState.isAllExpanded);
      setIsUnpublished(savedState.isUnpublished || false);
      setAllUnpublishPublish(savedState.allUnpublishPublish || []);
      setSelectedRows(savedState.selectedRows || []);

      staticsetPromtActions = savedState?.promtAction
      staticsetSelected = savedState?.selected

      isAllSelected =
        moreAttributes.length > 0 && savedState.selected.length === moreAttributes.length;
      FetchSubModules(savedState?.selectedCropYear, savedState?.selectedModuleId, true)

    }
  }, []);
  // Save state to sessionStorage whenever it changes
  ;

  useEffect(() => {
    // return
    const savedState = JSON.parse(sessionStorage.getItem('yourComponentState'));
    if (user && user?.userAttribute == "Local") {
      setIsGlobal(false)
      // Ensure columns are reset to the default local view
      setColumns([
        { id: 'questionCode', label: 'Question code' },
        { id: 'text', label: 'Question Text' },
        { id: 'active', label: 'Active' },
        { id: 'mandatory', label: 'Mandatory' },
        { id: 'audit', label: 'Audit' },
        { id: 'promptAction', label: 'Prompt Action' },
        { id: 'edit', label: 'Edit' },
      ])
    } else {
      if (user?.userAttribute == "Global") setIsGlobal(true)
      setColumns([
        { id: 'questionCode', label: 'Question code' },
        { id: 'text', label: 'Question Text' },
        { id: 'active', label: 'Active' },
        { id: 'mandatory', label: 'Mandatory' },
        { id: 'audit', label: 'Audit' },
        { id: 'promptAction', label: 'Prompt Action' },
        { id: 'publish', label: 'Published' },
        { id: 'edit', label: 'Edit' },
        { id: 'view', label: 'View' }
      ])
    }

    if (savedState != null || savedState?.cropYears?.length > 0) {
      return
    }
    FetchCropYears()
    fetchPickList()

  }, [user])


  useEffect(() => {
    const stateToSave = {
      isGlobal,
      loading,
      activeButton,
      clickCollapse,
      clickExpandable,
      expanded,
      cropYears,
      cropStages,
      selectedCropYear,
      selectedCropStages,
      modules,
      subModules,
      userInput,
      pickListData,
      moreAttributes,
      selected,
      promtAction,
      selectedModuleId,
      isAllExpanded,
      isUnpublished,
      allUnpublishPublish,
      selectedRows,

    };

    sessionStorage.setItem('yourComponentState', JSON.stringify(stateToSave));
  }, [
    isGlobal,
    loading,
    activeButton,
    clickCollapse,
    clickExpandable,
    expanded,
    cropYears,
    cropStages,
    selectedCropYear,
    selectedCropStages,
    modules,
    subModules,
    userInput,
    pickListData,
    moreAttributes,
    selected,
    promtAction,
    selectedModuleId,
    isAllExpanded,
    isUnpublished,
    allUnpublishPublish,
    selectedRows,
  ])

useEffect(()=>{
  if(userInput){
  onHandleSearch(userInput)
  }
},[userInput])

  const onHandleSearch = (value) => {
    setUserInput(value);
    setTimeout(() => {
      debouncedSearch(value);
    }, 100);
  };

  // Create debounced search function using useCallback
const debouncedSearch = useCallback(
  debounce((searchValue) => {
    if (searchValue != "" || searchValue != undefined) {
      const params = new URLSearchParams();
      params.append('userInput', searchValue);
      
      if (staticsetPromtActions) {
        params.append('promptAction', staticsetPromtActions);
      }
      
      if (staticsetSelected?.length > 0) {
        staticsetSelected?.map((ele) => {
          params.append(ele?.name, true);
        });
      }

      setLoading(true);
      QuestionnareService.searchQuestion({ 
        selectedCropYear, 
        selectedCropStages, 
        params 
      })
      .then((res) => {
        setLoading(false);
        let data = res?.data?.response?.modules;
        if (data?.length === 0) {
          setMessage("No Modules has question with this input");
          setOpenAlert(true);
          setSeverity("error");
        }
        setModules(data);
        setSubModules(data[0]?.subModules);
        setActiveButton('questionnare-module-button0')

        
        if (isAllExpanded === true) {
          handleExpandAll();
        } else if (isAllExpanded === false) {
          handleCollapseAll();
        } else {
          handleAccordionChange(expanded);
        }
      })
      .catch((ex) => {
        console.log('error', ex);
        setLoading(false);
      });
    } else {
      FetchModules(selectedCropYear, selectedCropStages);
    }
  }, 800), // 800ms delay
  [selectedCropYear, selectedCropStages, isAllExpanded, expanded]
);

  const handleSetFilteredModules = ((subMod, isUnpublish) => {
    let subModuleCpy = [...subMod]
    if (isUnpublish == true) {
      subModuleCpy = filterQuestionsByAuditAndActive(subModuleCpy, "published", !isUnpublish);
    }
    //current state filter attributes
    if (selected.length > 0) {
      selected.forEach((ele) => {
        subModuleCpy = filterQuestionsByAuditAndActive(subModuleCpy, ele?.name, true);
      })
    }
    //previous state filter attributes
    if (savedState?.selected?.length > 0) {
      savedState?.selected?.forEach((ele) => {
        subModuleCpy = filterQuestionsByAuditAndActive(subModuleCpy, ele?.name, true);
      })
    }

    if (savedState?.promtAction != undefined) {
      subModuleCpy = filterQuestionsByAuditAndActive(subModuleCpy, "promptActionQue", savedState?.promtAction);
    } else {
      if (promtAction != undefined) {
        subModuleCpy = filterQuestionsByAuditAndActive(subModuleCpy, "promptActionQue", promtAction);
      }
    }
    setSubModules(subModuleCpy)
  });
  function filterQuestionsByAuditAndActive(response, type, value) {
    if (response?.length == 0) return
    let v = value;
    if (type == "promptActionQue") {
      let p_data = pickListData || savedState?.pickListData
      const index = p_data?.EQPACT?.findIndex(item => item.pickListId === value);
      v = p_data?.EQPACT[index]?.pickListDescription
    }
    const filteredResponse = response?.map(sub => {
      const s = {
        ...sub,
        questions: sub?.questions?.filter(q => q[type] == v)
      }

      return s
    })

    return filteredResponse;
  }
  const FetchCropYears = () => {
    SeasonRegistrationService.getCropYears().then((res) => {
      let data = res?.data?.response;
      const formattedYear = data?.map(({ cropYear, ...rest }) => ({
        cyCropYear: cropYear,
        ...rest
      }));
      setCropYears(formattedYear)
      let cyId = ""
      if (data?.length > 0) {
        const index = data?.findIndex(item => item?.isCurrentCropYear == true);
        cyId = data[index]?.cropYearUid
        setSelectedCropYear(cyId);
      }
      FetchYearAndStages(cyId)
    }).catch((ex) => {
      console.log('error', ex)
    })
  }
  const FetchYearAndStages = (cyId) => {
    setLoading(true)
    QuestionnareService.FetchDropdown().then((res) => {
      setLoading(false)
      let data = res?.data?.response;
      setCropStages(data?.cropStageResponse)
      if (data?.cropStageResponse.length > 0) {
        setSelectedCropStage(data?.cropStageResponse[0].cropStageUid);
      }
      FetchModules(cyId, data?.cropStageResponse[0].cropStageUid)
    }).catch((ex) => {
      console.log('error', ex)
      setLoading(false)
    })
  }
  const fetchPickList = () => {
    setLoading(true)
    CommonService.fetchPickList({ pickListCodes: ['EQPACT'] }).then((res) => {
      setLoading(false)
      let data = res?.data?.response;
      // if (!isGlobal) {
      if (user && user?.userAttribute == "Local") {
        let d = data?.['EQPACT']?.filter(item => !equalsIgnoreCase(item?.pickListDescription, "Extreme Breach") && !equalsIgnoreCase(item?.pickListDescription, "High Risk"));
        data = { EQPACT: d }
      }
      setPickListData(data)
    }).catch((ex) => {
      console.log('error', ex)
      setLoading(false)
    })
  }
  const removeAllDuplicates = (option) => {
    const occurrences = {};
    option?.forEach(item => {
      const key = `${item.id}-${item.name}`;
      occurrences[key] = (occurrences[key] || 0) + 1;
    });
    const uniqueData = option.filter(item => occurrences[`${item.id}-${item.name}`] === 1);
    return uniqueData;
  };
  const handleChangeAttributes = (event) => {
    const option = event.target.value;
    if (option[option.length - 1] === "all") {
      setSelected(selected.length === moreAttributes.length ? [] : moreAttributes);
      staticsetSelected = selected.length === moreAttributes.length ? [] : moreAttributes;
      return;
    }
    let updatedOptions = removeAllDuplicates(option)
    setSelected(updatedOptions);
    staticsetSelected = updatedOptions
  };
  function sortBySequence(arr) {
    return arr.sort((a, b) => a.sequence - b.sequence);
  }
  const FetchModules = (cropYearId, cropStageId) => {
    const params = new URLSearchParams();
    if (staticsetPromtActions != undefined && staticsetPromtActions != "") {
      params.append('promptAction', staticsetPromtActions);
    }
    if (staticsetSelected && staticsetSelected?.length > 0) {
      staticsetSelected?.map((ele) => {
        params.append(ele?.name, true)
      })
    }
    setLoading(true)
    QuestionnareService.FetchModulesList({ cropYearId, cropStageId, params }).then((res) => {
      setLoading(false)
      let data = res?.data?.response?.modules;
      if (selectedModuleId == "") {
        setSelectedModuleId(data[0]?.moduleId)
      }
      setModules(sortBySequence(data));
      setActiveButton('questionnare-module-button0')
      FetchSubModules(cropYearId, data[0]?.moduleId, true)
    }).catch((ex) => {
      console.log('error', ex)
      setLoading(false)
    })
  }
  const FetchSubModules = (cropYearId, moduleId, status) => {
    setLoading(true)
    QuestionnareService.FetchSubModules({ cropYearId, moduleId,userInput }).then((res) => {
      setLoading(false)
      setSelectedModuleId(moduleId)
      let data = res?.data?.response?.subModules;
      data = sortBySequence(data)
      if (data?.length == 0) {
        setMessage("No SubModules");
        setOpenAlert(true);
        setSeverity("error");
      }
      // setSubModules(data);
      setSelectedRows([])
      setAllUnpublishPublish(data)
      handleSetFilteredModules(data, isUnpublished)
      setLoading(false)
    }).catch((ex) => {
      console.log('error', ex)
      setLoading(false)
      setSubModules([])
    })
  }
  useEffect(() => {
    if (isAllExpanded == true) {
      handleExpandAll()
    } else if (isAllExpanded == false) {
      handleCollapseAll()
    } else {
      handleAccordionChange(expanded)
    }
  }, [subModules])
  const handleModuleButtonClick = (buttonId, moduleId) => {
    setActiveButton(buttonId);
    setSelectedModuleId(moduleId)
    FetchSubModules(selectedCropYear, moduleId, true)
  };
  const handleGetButton = () => {
    setUserInput("")
    FetchModules(selectedCropYear, selectedCropStages)
  }

  const activeButtonStyle = {
    color: "#103367",
    backgroundColor: "#C9D6EF",
    border: "1px solid #103367",
  };
  const handleToggle = (id, field, value) => {
    const params = new URLSearchParams();
    params.append(field, value)
    setLoading(true)
    QuestionnareService.updateByCheckbox({ data: { [field]: value }, questionId: id, modifiedByUser: user ? user?.userName : "" }).then((res) => {
      setLoading(false)
      let data = res?.data?.statusCode;
      if (data == 200) {
        let mId = selectedModuleId;
        if (mId == "" || mId == undefined) {
          mId = modules[0]?.moduleId
        }
        FetchSubModules(selectedCropYear, mId)
        setMessage("Saved Successfully");
        setOpenAlert(true);
        setSeverity("success");
      }
    }).catch((ex) => {
      console.log('error', ex)
      setLoading(false)
      setMessage("Update Failed");
      setOpenAlert(true);
      setSeverity("error");
    })
  };
  const handleEdit = (QuestionId, type ) => {

    if (type == "Edit") navigate('/QuestionnaireEdit', { state: { mode: type, QuestionId } })
    if (type == "View") {
      if (!isGlobal) navigate('/QuestionnaireView', { state: { mode: type, QuestionId,read_only_user } })
         if (isGlobal) navigate('/QuestionnaireView', { state: { mode: type, QuestionId } })
    }
  if (type == "newView") {
         if (isGlobal) navigate('/QuestionnaireEdit', { state: { mode: type, QuestionId } })
    }
  
     
    
  };
  const handleExpandAll = () => {
    const allIndexes = subModules?.map((_, index) => index);
    setExpanded(allIndexes);
    setIsAllExpanded(true)
  };
  const handleCollapseAll = () => {
    setIsAllExpanded(false)
    setExpanded([]);
  };
  const handleExpand = () => {
    setClickExpandable(true)
    setClickCollapse(false)
    handleExpandAll()
  }
  const handleCollapse = () => {
    setClickExpandable(false)
    setClickCollapse(true)
    handleCollapseAll()
  }
  const handleAccordionChange = (index, e) => {
    if (e?.isTrusted == undefined) {
      setExpanded(savedState?.expanded)

    } else {
      const newExpanded = [...expanded];
      if (newExpanded?.includes(index)) {
        const indexToRemove = newExpanded.indexOf(index);
        newExpanded.splice(indexToRemove, 1);
      } else {
        newExpanded.push(index);
      }

      setExpanded(newExpanded);
    }
  };
  const handleUnpublish = (checked) => {
    setIsUnpublished(checked)
    handleSetFilteredModules(allUnpublishPublish, checked)
  }
  const handleRowSelect = (checked, row) => {
    if (checked) {
      setSelectedRows((prevSelectedRows) => [
        ...prevSelectedRows,
        row,
      ]);
    } else {
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter(rows => rows.questionId != row.questionId)
      );
    }
  };
  const handleRowSelectAll = (checked, index) => {
    if (checked) {
      let bulkArray = subModules[index]?.questions;
      let filtered = bulkArray?.filter(item => !item.published)
      const mergedArray = [...selectedRows, ...filtered];
      setSelectedRows(mergedArray);
    } else {
      const idsToRemove = new Set(subModules[index]?.questions?.map(item => item.questionId));
      setSelectedRows((prevSelectedRows) =>
        prevSelectedRows.filter(item => !idsToRemove.has(item?.questionId))
      );
    }

  };
  const checkIfRowSelectd = (questionId) => {
    let test = selectedRows?.some(row => String(row.questionId) == String(questionId));
    return test
  }
  const handlePublish = () => {
    if (selectedRows?.length < 1) {
      setMessage("Please select at least one question to publish");
      setOpenAlert(true);
      setSeverity("error");
    } else {
      let questionIds = selectedRows?.map(row => row.questionId);
      setLoading(true)
      QuestionnareService.publishQuestion({ questionIds, modifiedByUser: user ? user?.userName : "" }).then((res) => {
        setLoading(false)
        let data = res?.data?.statusCode;
        if (data == 200) {
          setMessage("Published Successfully");
          setOpenAlert(true);
          setSeverity("success");
          FetchSubModules(selectedCropYear, selectedModuleId)
        }
      }).catch((ex) => {
        console.log('error', ex)
        setLoading(false)
        setMessage("Publish Failed");
        setOpenAlert(true);
        setSeverity("error");
      })
    }
  }
  const setPromtAction = (id) => {
    const index = pickListData?.EQPACT?.findIndex(item => item.pickListId === id);
    setPromtActions(pickListData?.EQPACT[index]?.pickListId)
    staticsetPromtActions = pickListData?.EQPACT[index]?.pickListDescription
  }

  useEffect(() => {
    // Set a timeout to delay rendering the content by 1 second
    const timeout = setTimeout(() => {
      setShowContent(true); // Change state after 1 second
    }, 100);

    // Cleanup the timeout if the component is unmounted
    return () => clearTimeout(timeout);
  }, []);

 const handleFilterDataExport = async () => {
  try {
    setLoading(true);

    const params = new URLSearchParams();
    params.append('cropYearId', selectedCropYear);
    params.append('cropStageId', selectedCropStages);



    if (userInput) {
      params.append('keyword', userInput);
    }

    if (promtAction !== undefined && promtAction !== "") {
  const index = pickListData?.EQPACT?.findIndex(item => item.pickListId === promtAction);
  if (index !== -1) {
    const promptActionValue = pickListData?.EQPACT[index]?.pickListDescription;
    params.append('promptActionValue', promptActionValue);
  }
}
    
    // Check if active filter is applied
    const activeFilter = selected.find(item => item.name === 'active');
    if (activeFilter) {
      params.append('isActive', true);
    }
    
    // // Check if audit filter is applied
    const auditFilter = selected.find(item => item.name === 'audit');
    if (auditFilter) {
      params.append('isAudit', true);
    }
    
    // // Check if mandatory filter is applied
     const mandatoryFilter = selected.find(item => item.name === 'mandatory');
    if (mandatoryFilter) {
      params.append('isMandatory', true);
    }
 
  
    const questionResponse = await QuestionnareService.exportQuestionData({ params });

    exportData(questionResponse?.data?.response || []);
    setLoading(false);
  
  } catch (error) {
    console.error('API call failed:', error);
    setMessage("Export failed");
    setOpenAlert(true);
    setSeverity("error");
  } finally {
    setLoading(false);
    setOpenExportToExcelModal(false);
  }
};

const handleAllDataExport = async () => {
  try {
    setLoading(true);

   const params = new URLSearchParams();
    params.append('cropYearId', selectedCropYear);

    const questionResponse = await QuestionnareService.exportQuestionData({ params });

    exportData(questionResponse?.data?.response || []);
     setLoading(false);
  
  }catch (error) {
    console.error('API call failed:', error);
  } finally {
    setLoading(false);
    setOpenExportToExcelModal(false);
  }
};

const exportData = (data) => {
  if (data.length === 0) {
    setSeverity("warning");
    setMessage("No data available to export");
    setOpenAlert(true);
    return;
  }
  try {
    const exportData = data.map(item => {
      const baseData = {
        'Crop year': item.cropYear,
        'Crop stage': item.cropStageName,
        'Module name': item.moduleName,
        'Sub module name': item.subModuleName,
        'Countries': item.countries?.replaceAll(',', ' |'),
        'Question code': item.questionCode,
        'Question type': item.questionType,
        'Question sequence': item.questionSequence,
        'Response type': item.responseType,
        'Minimum Value': item.minimumValue,
        'Maximum Value': item.maximumValue,
      };

      // Add conditional columns for Global users only
      if (isGlobal) {
        baseData['Mandatory Countries'] = item.mandatoryFlagCountries?.replaceAll(',', ' |');
        baseData['Mandtory'] = item.mandatoryFlag
        baseData['Audit Countries'] = item.auditFlagCountries?.replaceAll(',', ' |');
        baseData['Audit'] = item.auditFlag
        baseData['Active Countries'] = item.activeFlagCountries?.replaceAll(',', ' |');
        baseData['Active'] = item.activeFlag;
      } else {
        // For local users
        baseData['Mandtory'] = item.mandatoryFlag
        baseData['Audit'] = item.auditFlag
        baseData['Active'] = item.activeFlag;
      }

      // Continue with remaining columns
      const remainingData = {
        'Multi instance': item.multiInstanceFlag,
        'Prompt action': item.promptActionValue,
        'Prompt action Response condition': item.promptActionResponseCondition,
        'Prompt action reponse': item.promptActionResponse,
        'Parent question': item.parentQuestion,
        'Parent condition': item.parentQuestionResponseCondition,
        'Parent response': item.parentQuestionResponse,
        'Validation Question': item.validationQuestion,
        'Validation condition': item.validationCondition,
        'Pre-populate': item.prePopulatedFlag,
        'Calculated': item.calculatedFlag,
        'Calculation': item.calculation,
        'Question text': item.questionText,
      };

      // Add Question Translation only for Local users
      if (!isGlobal) {
        remainingData['Question Translation'] = item.questionTextLL;
      }

      return { ...baseData, ...remainingData };
    });
   
    const allowedTypes = ["Dropdown", "Multi Select Dropdown"];
    const responseSheetData = [];
    data.forEach(item => {
      if (
        allowedTypes.includes(item.responseType) &&
        Array.isArray(item.standardResponses)
      ) 
      {const sortedResponses = item.standardResponses.sort((a, b) => {
  const codeA = a.responseCode ?? ''; // default to empty string if null/undefined
  const codeB = b.responseCode ?? '';
  return codeA.localeCompare(codeB);
});

sortedResponses.forEach(resp => {
          const responseEntry = {
            'response code': resp.responseCode,
            'response': resp.responseText,
          };
          if (isGlobal) {
            responseEntry['Priority response'] = resp.priorityResponseFlag;
            responseEntry['Mandatory'] = resp.mandatoryFlag
          } else {
            responseEntry['response translation'] = resp.responseTextLL
            responseEntry['Priority response'] = resp.priorityResponseFlag;
            responseEntry['Active'] = resp.activeFlag
          }
          responseSheetData.push(responseEntry);
        });
      }
    });

    // Create workbook and add both sheets
    const wb = XLSX.utils.book_new();
    const questionnaireWS = XLSX.utils.json_to_sheet(exportData);
    const responseWS = XLSX.utils.json_to_sheet(responseSheetData);
    XLSX.utils.book_append_sheet(wb, questionnaireWS, "Questions");
    XLSX.utils.book_append_sheet(wb, responseWS, "Dropdown Responses");
    // Export as Excel (.xlsx supports multiple sheets)
    XLSX.writeFile(wb, `Questionnaire Setup.xlsx`);
  } catch (error) {
    console.error("Error exporting to Excel:", error);
    setSeverity("error");
    setMessage("Failed to export Excel file");
    setOpenAlert(true);
  }
};

  return (
    <Layout title="Questionare Setup">
      {showContent ?
        <div className="Questionnare-setup-container">
          <div
            style={{
              fontWeight: 600,
              fontSize: "1.25rem",
              color: "rgba(115, 125, 134, 1)",
              marginBottom: "1rem",
              paddingLeft: "0.5rem",
            }}
          >
            Questionnaire Setup
          </div>
          <div>
            <>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} sx={{ marginLeft: "-8px" }}>
                  <FormControl sx={{ m: 1, minWidth: '200px' }}>
                    <TextField
                      select
                      value={selectedCropYear}
                      onChange={(event) => setSelectedCropYear(event.target.value)}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      label={"Crop Year"}
                    >
                      {/* <MenuItem value={"default"}>Crop Year</MenuItem> */}
                      {cropYears?.map((year) => (
                        <MenuItem key={year?.cropYearUid} value={year?.cropYearUid}>
                          {year?.cyCropYear}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                  <FormControl sx={{ m: 1, minWidth: '200px' }}>
                    <TextField
                      select
                      onChange={(event) => setSelectedCropStage(event.target.value)}
                      value={selectedCropStages}
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      label={"Crop Stage"}
                    >
                      {cropStages?.map((stage) => (
                        <MenuItem key={stage?.cropStageUid} value={stage?.cropStageUid}>
                          {stage?.cropStageName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </FormControl>
                  <FormControl sx={{ m: 1, minWidth: '200px' }}>
                    <TextField
                      select
                      value={promtAction}
                      onChange={(e) => setPromtAction(e.target.value)}
                      displayEmpty
                      label={"Prompt Action"}
                      inputProps={{ "aria-label": "Without label" }}
                      
                    >
                      <MenuItem value={""}>Prompt Action</MenuItem>
                      {
                        pickListData?.EQPACT?.map((option) => (
                          <MenuItem
                            key={option?.pickListId}
                            value={option?.pickListId}
                          >
                            {option?.pickListDescription}

                          </MenuItem>
                        ))
                      }
                    </TextField>
                  </FormControl>
                  <FormControl sx={{ m: 1, minWidth: '200px' }}>
                    <TextField
                      select
                      label="More Attributes" // This will be displayed as the label
                      placeholder="" // Placeholder text
                      value={selected}
                      onChange={handleChangeAttributes}
                      SelectProps={{
                        multiple: true,
                        renderValue: (selected) =>
                          selected.map((select) => select.name).join(', '),
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                              overflowY: 'auto',
                            },
                          },
                        },
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            {/* Add any adornment if needed */}
                          </InputAdornment>
                        ),
                      }}
                    >
                      <MenuItem value="all">
                        <ListItemIcon>
                          <Checkbox
                            checked={isAllSelected}
                            indeterminate={selected.length > 0 && selected.length < moreAttributes.length}
                            icon={<img src={CheckboxUntick} alt="Unchecked" />}
                            checkedIcon={<img src={CheckboxTick} alt="Checked" />}
                          />
                        </ListItemIcon>
                        <ListItemText primary="Select All" />
                      </MenuItem>
                      {moreAttributes && moreAttributes.map((option) => (
                        <MenuItem key={option?.id} value={option}>
                          <ListItemIcon>
                            <Checkbox
                              checked={selected.find(ele => ele?.id === option?.id) !== undefined}
                              icon={<img src={CheckboxUntick} alt="Unchecked" />}
                              checkedIcon={<img src={CheckboxTick} alt="Checked" />}
                            />
                          </ListItemIcon>
                          <ListItemText primary={option?.name} />
                        </MenuItem>
                      )
                      )}
                    </TextField>

                  </FormControl>
                  <Button
                    sx={{
                      borderRadius: 4,
                      minWidth: 100,
                      minHeight: 50,
                      background: "#102A62",
                      marginTop: "13px",
                      marginLeft: "10px",
                    }}
                    variant="contained"
                    onClick={() => handleGetButton()}
                    disabled={loading}
                  >
                    {loading && <CircularProgress size={20} />}
                    Get
                  </Button>
                  {isGlobal &&
                    <Button
                      // disabled={selectedRows?.length < 1}
                      sx={{
                        borderRadius: 4,
                        minWidth: 100,
                        minHeight: 50,
                        background: "#EF7D00",
                        marginTop: "13px",
                        marginLeft: "20px",
                        "&:hover": {
                          backgroundColor: "#EF7D00",
                        },
                         '&.Mui-disabled': {
                        backgroundColor: "#EF7D00", 
                        color: "#ffffff",    
                        opacity: 0.5,          
                        },
                      }}
                      variant="contained"
                      type="button"
                      onClick={(e) => handlePublish()}
                      disabled={read_only_user}
                    >
                      {loading && <CircularProgress size={20} />}
                      {"PUBLISH"}
                    </Button>
                  }
                  {/* {isGlobal &&
                    <Button
                      sx={{
                        borderRadius: 100,
                        minWidth: 95,
                        minHeight: 50,
                        marginTop: "13px",
                        background: "#102A62",
                        marginLeft: { xs: 1 },
                        //float: "right"
                      }}
                      variant="contained"
                      startIcon={<AddCircleIcon />}
                      onClick={() => navigate("/Questionnaire", { state: { mode: "Add" } })}
                      disabled={loading}
                    >
                      {loading && <CircularProgress size={20} />}
                      Add
                    </Button>
                  } */}
                  <Button
                                              sx={{
                                                borderRadius: "10px",
                                                minWidth: 182,
                                                minHeight: 50,
                                                background: "#102A62", 
                                                marginTop: "10px",
                                                marginLeft: "20px",
                                                float:"right",
                                                "&:hover": {
                                                  backgroundColor: "#102A62",
                                                },
                                                padding:'8px 14px',
                                                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", 
                                                fontFamily:"Montserrat",
                                                fontWeight:"600",
                                                fontSize:"16px",
                                      
                                              }}
                                              variant="contained"
                                              onClick={()=>setOpenExportToExcelModal(true)}
                                              disabled={loading}
                                            >
                                              {loading && <CircularProgress size={20} />}
                                              EXPORT TO EXCEL
                                            </Button> 
                                             <ExportToExcelModal
                                                        open={openExportToExcelModal} 
                                                        onClose={() => setOpenExportToExcelModal(false)}
                                                        onFilterData={handleFilterDataExport}
                                                        onAllData={handleAllDataExport}
                                                      />
                </Grid>
              </Grid>
              <>
                <Box sx={{ display: "flex", alignItems: "center", paddingTop: "20px", justifyContent: "space-between" }}>
                <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
                  <Box sx={{ width: "59%", paddingLeft: "0px" }}>
                    <TextField fullWidth className="user-search-input"
                      placeholder="Search" variant="outlined"
                      onChange={(event) => onHandleSearch(event.target.value)}
                      value={userInput}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="start">
                            {loading && <CircularProgress size={20} />}
                            <img src={iconSearchs} />
                          </InputAdornment>
                        ),
                        sx: {
                          borderRadius: "30px",
                        }
                      }}
                    />
                  </Box>
                  <Box sx={{ display: "flex", gap: 2, marginLeft: "20px" }}>
                    <div className={`collapseImageContainer ${clickExpandable ? 'clicked' : ''}`} onClick={() => handleExpand()}>
                      <img className="CollapseImage1" src={ExpandAll} />
                      <img className="CollapseImage2" src={ExpandAllBlue} />
                    </div>
                    <div className={`collapseImageContainer1 ${clickCollapse ? 'clicked' : ''}`} onClick={() => handleCollapse()}>
                      <img className="CollapseImage11" src={CollapseAll} />
                      <img className="CollapseImage22" src={CollapseAllBlue} />
                    </div>
                  </Box>
                   </Box>

                  {isGlobal &&
                    <Button
                      sx={{
                        borderRadius: 100,
                        minWidth: 95,
                        minHeight: 50,
                        background: "#102A62",
                        marginRight: 1,
                        '&.Mui-disabled': {
                        backgroundColor: "#102A62", 
                        color: "#ffffff",    
                        opacity: 0.6,          
                        },
                      }}
                      variant="contained"
                      startIcon={<AddCircleIcon />}
                      onClick={() => navigate("/Questionnaire", { state: { mode: "Add",readOnly:read_only_user } })}
                      disabled={loading || read_only_user}
                    >
                      {loading && <CircularProgress size={20} />}
                      Add
                    </Button>
                  }
                </Box>
                <Box sx={{ marginLeft: "-8px" }}>
                  <Grid container spacing={1} justifyContent="flex-start">
                    {modules?.map((ele, index) => {
                      return (<Grid item><Button
                        sx={{
                          borderRadius: 4,
                          width: "max-content",
                          minHeight: 50,
                          marginTop: "20px",
                          marginLeft: "10px",
                          fontWeight: 600,
                          letterSpacing: "0.5px"
                        }}
                        variant="contained"
                        id={`questionnare-module-button${index}`}
                        style={activeButton === `questionnare-module-button${index}` ? activeButtonStyle : { color: "#000000", backgroundColor: "#E8E8E8", border: "1px solid #737D86" }}
                        onClick={() => handleModuleButtonClick(`questionnare-module-button${index}`, ele?.moduleId)}
                      >{ele?.moduleName}</Button></Grid>)
                    })}
                  </Grid>
                </Box>
                {isGlobal &&
                  <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                    <Checkbox
                      checked={isUnpublished}
                      icon={<img src={CheckboxUntick} />}
                      checkedIcon={<img src={CheckboxTick} />}
                      onClick={(e) => handleUnpublish(e.target.checked)}
                    />Unpublished Questions
                  </Box>
                }
                <Box>
                  {subModules?.map((sub, sub_index) => {
                    return (<div style={{ marginTop: "20px" }}>
                      <Accordion
                        expanded={expanded?.includes(sub_index)}
                        onChange={(e) => handleAccordionChange(sub_index, e)}
                      >
                        <AccordionSummary
                          expandIcon={<img src={ArrowUpQuestion} />}
                          aria-controls="panel1-content"
                          id="panel1-header"
                        >
                          <Typography sx={{ fontSize: "18px", color: "#191E31", fontFamily: "Montserrat", fontWeight: 600 }}>{sub?.subModuleName} ({sub?.questions?.length})</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <TableContainer component={Paper} sx={{ maxHeight: 400, overflowY: 'auto' }}>
                            <Table>
                              <TableHead sx={{ backgroundColor: '#102A63' }}>
                                <TableRow>
                                  {sub?.questions?.length > 0 && columns?.map((column, index) => (
                                    <TableCell
                                      sx={{ color: '#fff', borderRight: '1px solid #ddd', textAlign: "center" }}
                                      key={column.id}> {(!isGlobal && column.label == "Edit") ? "Edit"
                                        : index == 0 ?
                                          (<Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

                                            <Box sx={{ color: "white !important" }}>     {isGlobal &&
                                              <Checkbox
                                                disabled={read_only_user}
                                                sx={{ color: "white !important" }}
                                                onClick={(e) => handleRowSelectAll(e.target.checked, sub_index)}
                                              />
                                            } </Box><Box>{column.label}</Box></Box>)
                                          : `${column.label}`
                                      }
                                    </TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {sub?.questions?.length > 0 && sub?.questions?.map((row, ind) => (
                                  <TableRow key={ind}>
                                    <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        {isGlobal &&
                                          <Checkbox
                                            disabled={read_only_user|| row?.published}
                                            // checked={row.active}
                                            checked={checkIfRowSelectd(row?.questionId)}
                                            onClick={(e) => handleRowSelect(e.target.checked, row)}
                                          />
                                        }
                                        <Box sx={{ alignItems: "center", display: "flex" }}>{row.questionCode}</Box>
                                      </Box>

                                    </TableCell>
                                    <TableCell sx={{
                                      borderRight: '1px solid #ddd',
                                      wordBreak: 'break-word',
                                      overflowWrap: 'break-word',
                                      maxWidth: 300,
                                      minWidth: 200,
                                    }}>{row.questionText}</TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                      <Checkbox
                                        disabled={read_only_user||(!isGlobal && row.globalActive == true) || loading ? true : false}
                                        checked={row.active}
                                        onClick={() => {
                                          setActiveQuestion(!row?.active)
                                          handleToggle(row.questionId, 'isActive', !row.active)
                                        }}
                                        sx={{
                                             '&.Mui-disabled.Mui-checked': {
                                              color: '#112A63',
                                              opacity:0.6
                                                }
                                              }}
                                      />
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                      <Checkbox
                                        disabled={read_only_user||(!isGlobal && row?.globalMandatory == true) || loading ? true : false}
                                        checked={row.mandatory}
                                        sx={{
                                             '&.Mui-disabled.Mui-checked': {
                                              color: '#112A63',
                                              opacity:0.6
                                                }
                                              }}
                                        onClick={() => handleToggle(row.questionId, 'isMandatory', !row.mandatory)}
                                      />
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                      <Box onClick={()=>{
                                        if(row?.active===false){
                                          setActiveQuestion(false)
                                          setOpenAuditConfirmModal(true)
                                        }
                                        return
                                      }}>
                                        <Checkbox
                                           disabled={read_only_user || (!isGlobal && row?.globalAudit == true) || loading || row?.active === false}
                                          checked={row?.audit}
                                          onClick={() => {
                                            if(row?.audit || (!row?.isChildQuestion && !row?.isCalculated && !row?.isValidatedQuestion)){
                                              handleToggle(row.questionId, 'isAudit', !row?.audit)
                                            }
                                            else{
                                              setActiveQuestion(true)
                                              setOpenAuditConfirmModal(true)
                                              row?.isChildQuestion ? setQuestionType("child"):
                                              row?.isCalculated ? setQuestionType("calculated") :
                                              row?.isValidatedQuestion && setQuestionType("validated")
                                              setAuditData({
                                                questionId:row.questionId,
                                                audit:!row?.audit})
                                              }}
                                            }
                                             sx={{
                                             '&.Mui-disabled.Mui-checked': {
                                              color: '#112A63',
                                              opacity:0.6
                                                }
                                              }}
                                          />
                                          </Box>
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                      {isGlobal && <div>{row.promptActionQue}</div>}
                                      {!isGlobal && (row.promptActionQue == "Low Medium Risk" || row.promptActionQue == "No") &&
                                        <div>
                                          <Checkbox
                                            disabled={read_only_user||(!isGlobal && row?.globalPromptActionQue == "Low Medium Risk") || loading ? true : false}
                                            onClick={() => handleToggle(row.questionId, 'promptAction', row.promptActionQue == "Low Medium Risk" ? "No" : "Low Medium Risk")}
                                            checked={row.promptActionQue == "Low Medium Risk" ? true : false} />
                                        </div>}
                                    </TableCell>
                                    {/* <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>{row.promptActionQue}</TableCell> */}
                                    {isGlobal && <TableCell sx={{ borderRight: '1px solid #ddd', textAlign: "center" }}>
                                      <Checkbox
                                        disabled={read_only_user||loading}
                                        checked={row?.published}
                                        sx={{
                                             '&.Mui-disabled.Mui-checked': {
                                              color: '#112A63',
                                              opacity:0.6
                                                }
                                              }}
                                        onClick={() => handleToggle(row?.questionId, 'isPublish', !row?.published)}
                                      />
                                    </TableCell>}
                                    <TableCell sx={{ textAlign: "center" }}>
                                      <IconButton disabled={isGlobal ? read_only_user ? true : false : false} color="primary" onClick={() => (row.published && isGlobal) ? "" : handleEdit(row.questionId, isGlobal ? "Edit" : "View")} >
                                        <img src={isGlobal && read_only_user? EditDisabledIcon:isGlobal ? row.published ? EditDisabledIcon : EditEnabeldIcon : row.responseType == "Numeric" || row.responseType == "Integer" ? EditEnabeldIcon : EditEnabeldIcon} />
                                      </IconButton>
                                    </TableCell>
                                    {isGlobal && <TableCell sx={{ borderLeft: '1px solid #ddd',textAlign: "center" }}>
                                      <IconButton color="primary" onClick={()=>handleEdit(row.questionId,"newView")} >
                                         <img src={viewEye} alt="View" />
                                      </IconButton>
                                    </TableCell>}
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    </div>)
                  })}
                </Box>
              </>
            </>
          </div>
          <AuditConfirmModal
            questionType={questionType}
            activeQuestion={activeQuestion}
            open={openAuditConfirmModal}
            onClose={() => setOpenAuditConfirmModal(false)}
            onConfirm={()=>{
              handleToggle(auditData.questionId,'isAudit',auditData.audit)
              setOpenAuditConfirmModal(false)
            }}/>
        </div>
        : <div>
          {/* Loading... */}
        </div>}
    </Layout >
  );
};
export default QuestionnareContainer;
